
import { Component, Vue, Watch } from 'vue-property-decorator';
import SectionKpiCard from '../../components/KPIs/SectionKpiCard.vue';
import RouteTitle from '@/components/RouteTitle.vue';
import UIUtil from '@/utils/ui.util';
import RouterUtil from '@/utils/router.util';
import { RouteConfig } from 'vue-router';

@Component({
  components: {
    RouteTitle,
    SectionKpiCard,
  },
})
export default class SectionKpiCards extends Vue {
  sections: RouteConfig[] = [];

  generateSrc(fileName: string): string {
    return UIUtil.generateImagePathbyFileName(fileName);
  }

  getPath(child: RouteConfig): string {
    return `${this.$route.path}/${child.path}`;
  }

  sortRoutes(a: RouteConfig, b: RouteConfig): number {
    if (a.meta && a.meta.userAllowed && (!b.meta || !b.meta.userAllowed))
      return -1;
    if (b.meta && b.meta.userAllowed && (!a.meta || !a.meta.userAllowed))
      return 1;
    return 0;
  }

  getCards(): void {
    this.sections = RouterUtil.getChildrenByParentPath(
      this.$route.path,
      this.$store.state.user.userRoutes
    ).filter(
      (router) =>
        !router.meta?.hiddenOnNavigation && router.meta?.active !== false
    );
    this.sections.sort(this.sortRoutes);
  }

  mounted(): void {
    this.getCards();
  }
}
